import { useCallback, useRef, useState } from "react";
import { toast } from "react-toastify";
import { postsService } from "../../../../services/api/postsService";
import { buildAuthorizationExportPayload } from "../utils/authorizationExportForm";
import { downloadDocxBlob } from "../utils/downloadDocxBlob";

const buildAuthorizationFilename = (postName = "") => {
  const safeName = postName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .toLowerCase();

  return `${safeName || "giay-uy-quyen"}-${Date.now()}.docx`;
};

export const useAuthorizationFileExport = ({
  postId,
  postName,
  templateUrl,
  token,
}) => {
  const [exporting, setExporting] = useState(false);
  const exportingRef = useRef(false);

  const exportFile = useCallback(
    async (values) => {
      if (!postId || !token || exportingRef.current) return;

      if (!templateUrl) {
        toast.error("Không tìm thấy file mẫu giấy ủy quyền.");
        return false;
      }

      exportingRef.current = true;
      setExporting(true);
      try {
        const response = await postsService.exportAuthorizationFile(
          postId,
          buildAuthorizationExportPayload({ templateUrl, values }),
          token,
        );

        downloadDocxBlob(response, buildAuthorizationFilename(postName));
        toast.success("Xuất file thành công.");
        return true;
      } catch (error) {
        toast.dismiss();
        toast.error(
          error.response?.data?.message || "Không thể xuất file. Vui lòng thử lại.",
        );
        throw error;
      } finally {
        exportingRef.current = false;
        setExporting(false);
      }
    },
    [postId, postName, templateUrl, token],
  );

  return { exporting, exportFile };
};
